const VERSION = '2.0.20b'
export default VERSION
